import React from 'react';
import { Link } from 'react-router-dom';

const PageHero = ({ eyebrow, title, desc, children }) => (
  <section className="hero-green text-white">
    <div className="sib-container py-16 md:py-20">
      {eyebrow && <div className="eyebrow text-[#D4A840] mb-3">{eyebrow}</div>}
      <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4" style={{fontFamily:"'Playfair Display',serif"}}>{title}</h1>
      {desc && <p className="text-white/85 text-lg max-w-3xl leading-relaxed">{desc}</p>}
      {children}
    </div>
  </section>
);

export default PageHero;
